export { default as UiModal } from "./UiModal";
